module.exports = __webpack_public_path__ + "static/media/logomarca200px.3a64f021.png";